<template>
  <div class="flex justify-center md:p-10 invisible md:visible">
    <iframe src="https://www.tempo.com/getwid/06d97bff1d8bb77ad5b43ee9f1821b4b" scrolling="no" name="flipe" style="width: 661px; color: rgb(134, 134, 134); height: 85px;" frameborder="0"></iframe>
  </div>
  <div class="-mt-16 md:mt-0">
    <p class="bg-custom-orange text-center font-medium text-white p-2">Precisa de ajuda? Suporte no telefone | Jardim Primavera: 2773-6338</p>
  </div>
</template>